import ProjectedIncomeChart from './index'

const projectedIncomeModule = {
  ProjectedIncomeChart
}

export default projectedIncomeModule
